import keys from 'lodash/keys';
import { propTypes as flexPropTypes } from './flex';
import { propTypes as flexItemPropTypes } from './flex-item';

export const flexProps = [...keys(flexPropTypes), ...keys(flexItemPropTypes)];
